(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quvro-scratch-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-quvro-scratch-popup]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('.quvro-scratch-dialog');
      const canvas = root.querySelector('[data-quvro-canvas]');
      const closeButton = root.querySelector('[data-quvro-close]');
      const copyButton = root.querySelector('[data-quvro-copy]');
      const revealButton = root.querySelector('[data-quvro-reveal]');
      const actions = root.querySelector('[data-quvro-actions]');
      const hint = root.querySelector('[data-quvro-hint]');
      const storageKey = 'quvroScratchPopupSeen';
      const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
      let drawing = false;
      let lastPoint = null;
      let moveCount = 0;
      let revealed = false;

      const cameFromMeta = () => {
        const parameters = new URLSearchParams(window.location.search);
        const source = (parameters.get('utm_source') || '').toLowerCase();
        return parameters.has('fbclid') || ['facebook', 'instagram', 'meta', 'fb', 'ig'].includes(source);
      };

      const wasSeen = () => {
        try {
          return window.sessionStorage.getItem(storageKey) === 'true';
        } catch (error) {
          return false;
        }
      };

      const markSeen = () => {
        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          return;
        }
      };

      const sizeCanvas = () => {
        const rectangle = canvas.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rectangle.width * ratio);
        canvas.height = Math.round(rectangle.height * ratio);

        const context = canvas.getContext('2d', { willReadFrequently: true });
        const gradient = context.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#dfe4e7');
        gradient.addColorStop(0.35, '#aeb8bd');
        gradient.addColorStop(0.58, '#eef1f2');
        gradient.addColorStop(1, '#a9b3b8');
        context.globalCompositeOperation = 'source-over';
        context.fillStyle = gradient;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = '#3e514d';
        context.font = `700 ${Math.round(15 * ratio)}px Arial, sans-serif`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(root.dataset.scratchPrompt, canvas.width / 2, canvas.height / 2);
      };

      const pointFromEvent = (event) => {
        const rectangle = canvas.getBoundingClientRect();
        return {
          x: (event.clientX - rectangle.left) * (canvas.width / rectangle.width),
          y: (event.clientY - rectangle.top) * (canvas.height / rectangle.height)
        };
      };

      const finishReveal = () => {
        if (revealed) return;
        revealed = true;
        canvas.classList.add('is-revealed');
        actions.hidden = false;
        hint.hidden = true;
        revealButton.hidden = true;
      };

      const checkProgress = () => {
        const context = canvas.getContext('2d', { willReadFrequently: true });
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let transparent = 0;
        let sampled = 0;

        for (let index = 3; index < pixels.length; index += 80) {
          sampled += 1;
          if (pixels[index] < 40) transparent += 1;
        }

        if (transparent / sampled >= 0.42) finishReveal();
      };

      const scratch = (event) => {
        if (!drawing || revealed) return;
        event.preventDefault();
        const point = pointFromEvent(event);
        const context = canvas.getContext('2d', { willReadFrequently: true });
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        context.globalCompositeOperation = 'destination-out';
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.lineWidth = 38 * ratio;
        context.beginPath();
        context.moveTo(lastPoint.x, lastPoint.y);
        context.lineTo(point.x, point.y);
        context.stroke();
        lastPoint = point;
        moveCount += 1;
        if (moveCount % 7 === 0) checkProgress();
      };

      canvas.addEventListener('pointerdown', (event) => {
        if (revealed) return;
        drawing = true;
        lastPoint = pointFromEvent(event);
        canvas.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      canvas.addEventListener('pointermove', scratch);

      const stopDrawing = () => {
        if (!drawing) return;
        drawing = false;
        checkProgress();
      };

      canvas.addEventListener('pointerup', stopDrawing);
      canvas.addEventListener('pointercancel', stopDrawing);

      closeButton.addEventListener('click', () => dialog.close());
      revealButton.addEventListener('click', finishReveal);

      copyButton.addEventListener('click', async () => {
        const code = root.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }
        copyButton.textContent = root.dataset.copiedText;
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('quvro-scratch-open');
      });

      const showPopup = () => {
        if (!dialog || dialog.open) return;
        markSeen();
        dialog.showModal();
        document.documentElement.classList.add('quvro-scratch-open');
        window.requestAnimationFrame(sizeCanvas);
      };

      if (!isThemeEditor && wasSeen()) return;
      if (!isThemeEditor && root.dataset.metaOnly === 'true' && !cameFromMeta()) return;

      window.setTimeout(showPopup, Number(root.dataset.delay) || 2500);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
